export const PermissionEnum = {
  "Administrator": 1,
  "AdministratorHangfire": 5,
  "GlobalFilterEditor": 6,
  "ReadOnlyUser": 9999,
  "appConfig": 10000,
  "home": 10001,
  "loginForm": 10002,
  "eventLog_eventLogBrowse": 10005,
  "eventLog_eventLogDetail": 10006,
  "numberGenerator_numberGeneratorBrowse": 10013,
  "numberGenerator_numberGeneratorDetail": 10014,
  "permission_permissionGroupBrowse": 10015,
  "permission_permissionGroupDetail": 10016,
  "users_userOptionsDetail": 10038,
  "users_usersBrowse": 10039,
  "users_usersDetail": 10040,
  "eventLog": 10042,
  "numberGenerator": 10046,
  "permission": 10047,
  "users": 10054,
  "permission_permissionGroupLinkedTableSelector": 10055,
  "elementHelp": 10060,
  "elementHelp_elementHelpBrowse": 10061,
  "elementHelp_elementHelpDetail": 10062,
  "passwordResetForm": 10085,
  "home_dashboard": 10088,
  "home_dashboardTile": 10089,
  "home_dashboardTiles": 10090,
  "site": 10092,
  "site_siteBrowse": 10093,
  "site_siteDetail": 10094,
  "home_dashboardProjectReviewTable": 10095,
  "carrier": 10096,
  "carrier_carrierBrowse": 10097,
  "carrier_carrierDetail": 10098,
  "shipment": 10099,
  "shipment_shipmentBrowse": 10100,
  "shipment_shipmentDetail": 10101,
  "currency": 10102,
  "currency_currencyBrowse": 10103,
  "currency_currencyDetail": 10104,
  "shipment_shipmentCarrier": 10105,
  "shipment_shipmentPackage": 10106,
  "shipment_shipmentCarrierDetail": 10107,
  "shipment_shipmentCarrierBid": 10108,
  "shipmentAddress": 10109,
  "shipmentAddress_shipmentAddressBrowse": 10110,
  "shipmentAddress_shipmentAddressDetail": 10111,
  "shipment_shipmentCarrierWinner": 10112,
  "account": 10113,
  "home_dashboardMain": 10114,
  "account_accountBrowse": 10115,
  "account_accountDetail": 10116,
  "shipment_shipmentRoute": 10117,
  "shipment_shipmentTemplateBrowse": 10118,
  "shipmentAddressState": 10119,
  "shipmentAddressState_shipmentAddressStateBrowse": 10120,
  "shipmentAddressState_shipmentAddressStateDetail": 10121
};
export const LogObject = {
  "AppConfig": 1,
  "LV_ADDomain": 2,
  "Users": 3,
  "LV_Permission": 4,
  "PermissionGroup": 5,
  "PermissionGroupPermissionXRef": 6,
  "PermissionGroupUserXRef": 7,
  "LV_ADLocation": 8,
  "UserOptions": 9,
  "ElementHelp": 10,
  "PerformanceLog": 11,
  "Carrier": 12,
  "LV_ShipmentAddress": 13,
  "LV_ShipmentKind": 14,
  "LV_ShipmentState": 15,
  "LV_ShipmentType": 16,
  "Shipment": 17,
  "LV_Currency": 18,
  "ShipmentCarrier": 19,
  "ShipmentPackage": 20,
  "ShipmentAddress": 21,
  "LV_Account": 22,
  "ShipmentRoute": 23,
  "LV_ShipmentAddressState": 24,
  "Language": 25,
  "Undefined": -1
};
export const XCLogObject = {
  "Attachment": 10000,
  "UserFilter": 10001,
  "HelpTopic": 10002,
  "HelpTopicText": 10003,
  "UserSetting": 10004,
  "Translation": 10005,
  "HelpControl": 10006,
  "NumberGenerator": 10007,
  "EmailQueue": 10008,
  "HangfireService": 10009,
  "HangFireJobs": 10010,
  "Undefined": -1
};
export const BLOTablesEnum = {
  "DBUpdateVersion": 1,
  "ObjektID": 2,
  "SystemSetting": 3,
  "TableAudit": 4,
  "AppConfig": 5,
  "LV_ADDomain": 6,
  "Users": 7,
  "LV_Permission": 8,
  "PermissionGroup": 9,
  "PermissionGroupPermissionXRef": 10,
  "PermissionGroupUserXRef": 11,
  "Translation": 12,
  "LV_ADLocation": 13,
  "UserSetting": 14,
  "UserFilter": 15,
  "EventLog": 16,
  "LV_SerialNumberGeneratorType": 17,
  "NumberGenerator": 18,
  "NumberGeneratorCurrValue": 19,
  "EmailQueue": 20,
  "LV_Priority": 21,
  "LV_ProjectPhase": 22,
  "LV_ProjectUserXRefType": 23,
  "Project": 24,
  "ProjectProgressComment": 25,
  "ProjectPhaseHistory": 26,
  "ProjectUserXRef": 27,
  "Attachment": 28,
  "ProjectUserMonthXRef": 29,
  "UserOptions": 30,
  "HangfireService": 31,
  "ProjectGanttTask": 32,
  "ColorDefinition": 33,
  "LV_ExecutionSite": 34,
  "LV_FunctionalFunnel": 35,
  "LV_Impact": 36,
  "LV_Platform": 37,
  "LV_ProjectTrigger": 38,
  "ProjectExecutionSiteXRef": 39,
  "ProjectImpactXRef": 40,
  "ProjectPlatformXRef": 41,
  "LV_SteeringCommittee": 42,
  "SteeringCommitteeUserXRef": 43,
  "LV_ProjectStatus": 44,
  "ProjectExternalLink": 45,
  "SQLSession": 46,
  "ProjectCalc": 47,
  "ElementHelp": 48,
  "ProjectHistory": 49,
  "LV_CategoryL1": 50,
  "LV_CategoryL2": 51,
  "LV_InflationDriver": 52,
  "LV_LCRProject": 53,
  "LV_SavingInflation": 54,
  "LV_SavingsClassification": 55,
  "LV_ValueLever": 56,
  "PerformanceLog": 57,
  "ProjectSavingMonthXRef": 58,
  "LoginToken": 59,
  "LV_SavingType": 60,
  "LV_Site": 61,
  "SiteUserXRef": 62,
  "LV_FinancialCategory": 63,
  "agb_osdatalocal": 64,
  "eio_activity": 65,
  "eis_info": 66,
  "itw_dopravci": 67,
  "itw_konfigurace": 68,
  "itw_mista": 69,
  "itw_nabidky": 70,
  "itw_pravidelne": 71,
  "itw_pravidelnespecialni": 72,
  "itw_prepravy": 73,
  "itw_soubory": 74,
  "itw_ucty": 75,
  "itw_uzivatele": 76,
  "Carrier": 77,
  "LV_ShipmentAddress": 78,
  "LV_ShipmentKind": 79,
  "LV_ShipmentState": 80,
  "LV_ShipmentType": 81,
  "Shipment": 82,
  "LV_Currency": 83,
  "ShipmentOffer": 84,
  "ShipmentCarrier": 85,
  "ShipmentPackage": 86,
  "LV_Account": 87,
  "ShipmentRoute": 88,
  "HangFireJobs": 89,
  "LV_ShipmentAddressState": 90,
  "HelpControl": 91,
  "HelpTopic": 92,
  "HelpTopicText": 93,
  "LV_Language": 94
};
export const ShipmentStateEnum = {
  "Created": 1,
  "TenderRunning": 2,
  "TenderEnded": 3,
  "TenderFilling": 4,
  "Ready": 5,
  "NoTender": 6,
  "Canceled": 7,
  "FromTemplate": 8
};